import { RedDot } from "@/components/shared/ui/Badges";
import { Tab } from "@headlessui/react";
import React, { memo } from "react";

type TabProps = {
	labels: string[];
	children: React.ReactNode[];
	className?: string;
	tabHeaderOverride?: string;
	errorTabs?: Boolean[];
	disabledTabs?: boolean[];
	defaultIndex?: number;
	selectedIndex?: number;
	onChange?: (index: number) => void;
	noTopMarginOnContent?: boolean;
	customOnClick?: (index: number) => void;
	panelFooter?: React.ReactNode;
};

const CustomTab: React.FC<TabProps> = ({
	labels,
	children,
	className,
	tabHeaderOverride,
	errorTabs,
	disabledTabs,
	defaultIndex,
	selectedIndex,
	onChange,
	noTopMarginOnContent,
	customOnClick,
	panelFooter,
}) => {
	const isControlled = selectedIndex !== undefined && onChange !== undefined;

	return (
		<Tab.Group {...(isControlled ? { selectedIndex, onChange } : { defaultIndex: defaultIndex || 0 })}>
			<div className="w-full overflow-x-auto">
				<Tab.List className={`flex justify-between space-x-8 border-b-2 border-gray-200 md:space-x-16 ${className}`}>
					{labels.map((label, index) => {
						const isDisabled = disabledTabs && disabledTabs[index];
						return (
							<Tab
								className={`w-32 whitespace-nowrap border-b-4 py-2.5 text-xs uppercase outline-none transition-all
							 	duration-150 focus:outline-none ui-selected:border-secondary ui-selected:font-semibold ui-not-selected:border-transparent
								ui-not-selected:font-normal ${tabHeaderOverride || ""} ${
									isDisabled ? "cursor-not-allowed text-gray-400 opacity-[80%]" : ""
								}`}
								key={index + 1}
								disabled={isDisabled}
								onClick={() => {
									customOnClick?.(index);
								}}
							>
								{label}
								{errorTabs && errorTabs[index] && <RedDot />}
							</Tab>
						);
					})}
				</Tab.List>
			</div>
			<Tab.Panels className="w-full">
				{children?.length > 0 &&
					children?.map((child, index) => (
						<Tab.Panel key={index} className={`${noTopMarginOnContent ? "mt-0" : "mt-8"}`}>
							{child}
						</Tab.Panel>
					))}
			</Tab.Panels>
			{panelFooter}
		</Tab.Group>
	);
};

export default memo(CustomTab);
